"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddPersonalSubscriptionErrorResponse = exports.Name = exports.AddPersonalSubscriptionFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'add-personal-subscription-failed';
const AddPersonalSubscriptionFailedEvent = exports.AddPersonalSubscriptionFailedEvent = Name;
const isAddPersonalSubscriptionErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAddPersonalSubscriptionErrorResponse = isAddPersonalSubscriptionErrorResponse;
